import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["x", "y", "marker", "preview", "suggest", "status", "fields"]
  static values = { url: String, blobId: String, loading: String, ready: String, failed: String }

  connect() { this.update() }
  disconnect() { this.request?.abort() }

  cancel() {
    this.request?.abort()
    this.setBusy(false)
    this.statusTarget.textContent = ""
  }

  setBusy(busy) {
    this.element.closest("form").querySelectorAll('[type="submit"]').forEach(button => { button.disabled = busy })
    this.fieldsTarget.disabled = busy
    this.suggestTarget.disabled = busy
  }

  pick(event) {
    if (this.fieldsTarget.disabled) return
    const bounds = event.currentTarget.getBoundingClientRect()
    this.xTarget.value = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100)).toFixed(1)
    this.yTarget.value = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100)).toFixed(1)
    this.update()
  }

  reset() {
    this.xTarget.value = ""
    this.yTarget.value = ""
    this.update()
  }

  update() {
    const x = this.xTarget.value
    const y = this.yTarget.value
    this.markerTarget.style.left = `${x || 50}%`
    this.markerTarget.style.top = `${y || 50}%`
    for (const image of this.previewTargets) {
      for (const [axis, value] of [["x", x], ["y", y]]) {
        if (value === "") image.removeAttribute(`data-focal-image-${axis}-value`)
        else image.setAttribute(`data-focal-image-${axis}-value`, value)
      }
    }
  }

  async suggest() {
    this.request = new AbortController()
    this.setBusy(true)
    this.statusTarget.textContent = this.loadingValue
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" },
        body: JSON.stringify({ blob_id: this.blobIdValue }),
        signal: this.request.signal,
      })
      const point = await response.json()
      if (!response.ok) {
        this.statusTarget.textContent = point.error || this.failedValue
        return
      }
      this.xTarget.value = point.x
      this.yTarget.value = point.y
      this.update()
      this.statusTarget.textContent = this.readyValue
    } catch (error) {
      if (error.name !== "AbortError") this.statusTarget.textContent = this.failedValue
    } finally {
      this.setBusy(false)
    }
  }
}
